export enum BookingStatusEnum{
    Booked = 1,
    Cancelled = 2,
    ClosedMaintenance = 3,
    Scheduled = 4
}